var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex align-items-center justify-content-center"},[_c('h3',{staticClass:"no-data-dash text-center text-secondary"},[_vm._v("Não existem dados a serem exibidos")])])
}]

export { render, staticRenderFns }